module.exports = __webpack_public_path__ + "img/notice.70c49d1d.png";